import gql from 'graphql-tag';

export const AUTHOR_FRAGMENT = gql`
  fragment AuthorData on Author {
    id
    name
  }
`;
